import { useState, useRef } from 'react';
import { createElement } from 'react';
import { staged } from 'staged-components';
import { withNativeProps, toCSSLength, useIsomorphicUpdateLayoutEffect, mergeProps, } from './funtions';
import { LazyDetector } from './lazy-detector';
import ImageView from './imageView';
import defaultImg from './img/defaultImg.png';
const classPrefix = `adm-image`;
const defaultProps = {
    fit: 'fill',
    lazy: false,
    draggable: false,
};
export const Image = staged(p => {
    const props = mergeProps(defaultProps, p);
    const [loaded, setLoaded] = useState(false);
    const [showImg, setShowImg] = useState(false);
    const ref = useRef(null);
    let { src, imageview, buttonIconSrc, buttonText, buttonTextPosition = 'left', errorImg, onClick, buttonTextOnClick, buttonIconOnClick, } = props;
    let { srcSet } = props;
    const [isImageview, setIsImageview] = useState(imageview);
    const [initialized, setInitialized] = useState(!props.lazy);
    src = initialized ? props.src : undefined;
    srcSet = initialized ? props.srcSet : undefined;
    useIsomorphicUpdateLayoutEffect(() => {
        setLoaded(false);
    }, [src]);
    const _onClick = e => {
        onClick?.(e);
        if (isImageview) {
            setShowImg(!showImg);
        }
    };
    const _onError = e => {
        setIsImageview(false);
        const img = e.target;
        img.src = errorImg ?? defaultImg;
        img.onerror = null;
        props.onError?.(e);
    };
    const img = (createElement("img", { className: `${classPrefix}-img`, src: src, alt: props.alt || 'image', onClick: _onClick, onLoad: e => {
            setLoaded(true);
            props.onLoad?.(e);
        }, onError: e => {
            _onError?.(e);
        }, style: {
            objectFit: props.fit,
            display: loaded ? 'block' : 'none',
        }, crossOrigin: props.crossOrigin, decoding: props.decoding, loading: props.loading, referrerPolicy: props.referrerPolicy, sizes: props.sizes, srcSet: srcSet, useMap: props.useMap, draggable: props.draggable }));
    function renderInner() {
        return (createElement(React.Fragment, null,
            !loaded && props.placeholder,
            img,
            showImg && createElement(ImageView, { src: src, onClick: _onClick }),
            showImg && buttonIconSrc && (createElement("div", { className: 'image-view-ribbon', style: {
                    flexDirection: buttonTextPosition === 'left' ? 'row' : 'row-reverse',
                } },
                buttonText && (createElement("div", { className: 'text-button', onClick: buttonTextOnClick, "aria-label": buttonText, role: "button" },
                    createElement("span", null, buttonText))),
                buttonIconSrc &&
                    buttonIconSrc.slice(0, buttonText ? 3 : 4).map((item, index) => {
                        return (createElement("div", { key: index, className: 'img-button', onClick: () => buttonIconOnClick?.(item, index) },
                            createElement("img", { src: item.src, alt: item.alt })));
                    })))));
    }
    const style = {};
    console.log('props.width.......', props.width);
    console.log('props.height......', props.height);
    if (props.width) {
        style['--width'] = toCSSLength(props.width);
        style.width = toCSSLength(props.width);
    }
    if (props.height) {
        style['--height'] = toCSSLength(props.height);
        style.height = toCSSLength(props.height);
    }
    console.log('Image style.....', style);
    return withNativeProps(props, createElement("div", { ref: ref, className: classPrefix, style: style, onClick: props.onContainerClick },
        props.lazy && !initialized && (createElement(LazyDetector, { onActive: () => {
                setInitialized(true);
            } })),
        renderInner()));
});
